<template>
    <div class="nav-menu" v-show="menuList.length">
        <el-menu
            class="el-menu-vertical-demo"
            background-color="#F0F5FA"
            text-color="rgba(0, 0, 0, 0.65)"
            active-text-color="#ffffff"
            :unique-opened="unique"
            :default-active="current"
            @open="handleOpen"
            @close="handleClose"
        >
            <div v-if="level == 2">
                <div
                    v-for="menu in menuList"
                    :key="menu.id"
                    :class="{ 'no-icon': !menu.children.length }"
                >
                    <el-menu-item
                        :index="menu.id"
                        class="single"
                        @click="selectMenu(menu, '')"
                    >
                        <span>{{ menu.mname }}</span>
                    </el-menu-item>
                </div>
            </div>
            <div v-else>
                <div
                    v-for="menu in menuList"
                    :key="menu.id"
                    :class="{ 'no-icon': !menu.children.length }"
                >
                    <el-menu-item
                        :index="menu.id"
                        class="single"
                        v-if="!menu.children.length"
                        @click="selectMenu(menu, '')"
                    >
                        <span>{{ menu.mname }}</span>
                    </el-menu-item>
                    <el-submenu :index="menu.id" v-else>
                        <template slot="title" @click="selectMenu(menu, '')">
                            <span>{{ menu.mname }}</span>
                        </template>
                        <el-menu-item-group>
                            <el-menu-item
                                v-for="(item, j) in menu.children"
                                :key="j"
                                :index="item.id"
                                @click="selectMenu(item, menu)"
                                >{{ item.mname }}</el-menu-item
                            >
                        </el-menu-item-group>
                    </el-submenu>
                </div>
            </div>
        </el-menu>
    </div>
</template>

<script type="text/ecmascript-6">
    export default {
        name: 'nav-menu',
        props: {
            list: {
                type: Array
            },
            level: {
                type: Number,
                default: 3
            }
        },
        data() {
            return {
                unique: true,
                current: '',
                // menuList: [
                //   {
                //     id: "1",
                //     mname: "权限管理"
                //   },
                //   {
                //     id: "2",
                //     mname: "内容管理",
                //     children: [
                //       {
                //         id: "4",
                //         mname: "网站内容统计",
                //         nav: "content-statistic",
                //         url: "/admin/article/list"
                //       }
                //     ]
                //   },
                //   {
                //     id: "3",
                //     mname: "会员管理",
                //     children: [
                //       {
                //         id: "5",
                //         mname: "个人会员",
                //         nav: "personal",
                //         url: "/admin/user/userlist"
                //       },
                //       {
                //         id: "6",
                //         mname: "企业会员",
                //         nav: "enterprise",
                //         url: "/admin/user/userlist"
                //       },
                //       {
                //         id: "7",
                //         mname: "厂商会员",
                //         nav: "firm",
                //         url: "/admin/user/userlist"
                //       }
                //     ]
                //   }
                // ],
                menuList: this.list // 导航列表
            };
        },
        created() {},
        methods: {
            clearData() {
                this.current = '';
            },
            selectMenu(menu, top) {
                this.current = menu.id;
                this.$emit('menuChange', menu.id);
                let breadObj = [];
                if (top) {
                    breadObj.push({
                        name: top.mname,
                        path: 'article-list?id=' + top.id
                    });
                }
                breadObj.push({
                    name: menu.mname,
                    path: 'article-list?id=' + menu.id
                });
                this.$store.commit('pushBreadArr', breadObj);
                console.log(22222, menu);
            },
            handleOpen(key, keyPath) {
                this.current = key;
                this.$emit('menuChange', key);
                var menu = this.menuList.filter(function(item) {
                    return item.id == key;
                });
                let breadObj = [
                    {
                        name: menu[0].mname,
                        path: 'article-list?id=' + menu[0].id
                    }
                ];
                this.$store.commit('pushBreadArr', breadObj);
                console.log(key, keyPath, menu);
            },
            handleClose(key, keyPath) {
                this.current = key;
                console.log(key, keyPath);
            }
        },
        watch: {
            list(val, oval) {
                this.menuList = val;
                // console.log(33333, 'current', val);
                // if (val.length) {
                // this.current = val[0].id;
                // }
            }
        }
    };
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
    @import '~assets/main.styl';

    .nav-menu {
        width: 280px;
        padding: 16px;
        background: white;
        border-radius: 8px;
        box-sizing: border-box;
        border: none;
    }

    .single {
        ellipsis();
    }

    .no-icon {
        >>>.el-submenu {
            i {
                display: none;
            }
        }

        >>>.el-menu-item >>>.is-active {
            padding-left: 20px;
            color: blue !important;
            background-color: rgb(240, 245, 250) !important;
        }
    }

    .el-menu-vertical-demo {
        background-color: white !important;
    }

    .el-submenu.is-opened {
        .el-submenu__title {
            span {
                color: blue;
            }
        }
    }
</style>
